import { ChangeEventHandler, ReactElement, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useDebounce from '../../utils/hooks/useDebounce';

type SearchFormControlProps = {
  value?: string;
  delay?: number;
  onChange?: (value: string) => void;
  onDebouncedChange: (value: string) => void;
};

const SearchFormControl = ({
  value: valueProp = '',
  delay = 400,
  onChange,
  onDebouncedChange
}: SearchFormControlProps): ReactElement => {
  const { t } = useTranslation();
  const [value, setValue] = useState(valueProp);
  const debounced = useDebounce(value, delay);

  useEffect(() => {
    onDebouncedChange(debounced);
  }, [debounced, onDebouncedChange]);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const nextValue = event.target.value;
    setValue(nextValue);
    onChange?.(nextValue);
  };

  return (
    <TextField
      type='search'
      size='small'
      fullWidth
      placeholder={t('general.search.placeholder', 'Suchbegriff eingeben...')}
      value={value}
      onChange={handleChange}
    />
  );
};

export default SearchFormControl;
